/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Zip/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Zip({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Office/Zip",
  isInvalid,
  onChange
  
}) {
let editProfessionalOtherExternalOfficePostalAddressZipValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'other.external_office.postal_address.zip',
})
let editProfessionalOtherExternalOfficePostalAddressZipIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_professional',
path: 'other.external_office.postal_address.zip',
validate: fromValidate.zip,
required: true,
})
let editProfessionalOtherExternalOfficePostalAddressZipChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'other.external_office.postal_address.zip',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_professional.other.external_office.postal_address.zip"
 validate="/Data/validate.js zip"
 required={true}
 invalid={!editProfessionalOtherExternalOfficePostalAddressZipIsValidData}
 value={editProfessionalOtherExternalOfficePostalAddressZipValueData}
 onChange={editProfessionalOtherExternalOfficePostalAddressZipChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="ZIP Code"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}